<template>
    <div class="custom-work-confirmed">
        <i class="material-icons">check_circle</i>
        <h3>Order #{{ slug }}</h3>
        <h1>Your Order is Confirmed!</h1>
        <p>
            Delivery estimate is 5-7 weeks from order date.<br />
            A member of our team will reach out to you within 24 hours<br />
            Contact <a href="mailto:sales@paragonintel.com" class="primary-link-light">sales@paragonintel.com</a> with
            questions
        </p>
    </div>
</template>
<script>
export default {
    props: {
        order: {
            type: Array,
            required: true,
        },
    },
    computed: {
        slug() {
            return this.order[0].orderSlug
        },
    },
}
</script>
<style>
.custom-work-confirmed {
    display: flex;
    flex-direction: column;
    gap: 40px;
    justify-content: space-around;
    padding: 16px;

    > * {
        text-align: center;
        width: 100%;
    }

    .material-icons {
        color: var(--color-secondary-400);
        font-size: 64px;
    }
}
</style>
